/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var GetPrice = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'getPrice',
    description: 'This function returns the price of an asset in USD with 8 decimal places. Requires Chainlink Price Feed address',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                priceFeed: new FctAddress({}),
            },
        },
        output: {
            price: new FctValue({ innerIndex: 0 }),
        },
    }); },
});
